module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view"
  }, [_c('box', [_c('table', {
    staticClass: "table-a"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "align-l"
  }), _vm._v(" "), _c('th', {
    staticClass: "align-l"
  }, [_vm._v("Kunde")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Indtjening")]), _vm._v(" "), _c('th', {
    staticClass: "align-r"
  }, [_vm._v("Faktureret i Dinero")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.clients), function(client, client_i) {
    return _c('tr', [_c('td', [_c('avatar', {
      attrs: {
        "input": client
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "align-l"
    }, [_c('router-link', {
      staticClass: "textlink",
      attrs: {
        "to": '/client/' + client['.key']
      }
    }, [_vm._v(_vm._s(client.name))])], 1), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(client.earning_dkk, 2)) + " kr.")]), _vm._v(" "), _c('td', {
      staticClass: "align-r"
    }, [_vm._v(_vm._s(_vm._f("money")(client.invoiced_dkk, 2)) + " kr.")])])
  }), _vm._v(" "), _c('tr', [_c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    staticClass: "align-r"
  }, [_c('b', [_vm._v(_vm._s(_vm._f("money")(_vm.totalInvoiced, 2)) + " kr.")])]), _vm._v(" "), _c('td')])], 2)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e785009","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ReportClientEarning.vue
// module id = 608
// module chunks = 1